import { render, staticRenderFns } from "./TeamLeader.vue?vue&type=template&id=70c1f2c5&"
import script from "./TeamLeader.vue?vue&type=script&lang=js&"
export * from "./TeamLeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports